/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/Print
 * @desc Action to print an experiment workflow
 */

import EntityActionPrint from 'labstep-web/components/Entity/Action/Print';
import type React from 'react';
import type { ExperimentWorkflowActionPrintProps } from './types';

export const ExperimentWorkflowActionPrint: React.FC<
  ExperimentWorkflowActionPrintProps
> = ({ experimentWorkflow }) => (
  <EntityActionPrint entity={experimentWorkflow} />
);
